module.exports = __webpack_public_path__ + "static/media/donor_recognition_wall.07d68861.svg";